<template>
  <wizard-layout :id="this.step">
    <template>
      <wizard-box-left>
        <wizard-step :step="this.step" :header_step="this.header_step" :user="this.user"></wizard-step>
        <wizard-header :title="this.title"></wizard-header>

        <div class="row">
          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>Superficie*</label>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-control custom-form-control"><input class="custom-input-control" type="text" v-model="surface" required /><span class="before-input">mq</span></div>
                <span class="superficie-warning"> Se non conosci la metratura esatta puoi inserire un valore indicativo </span>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>Locali*</label>
              </div>
              <div class="col-lg-6 col-12 ml-2">
                <div class="form-group d-flex">
                  <span class="pt-1 mr-3"> {{ this.rooms }} </span>
                  <button class="minus ml-2 mr-2" @click="removeLocali"><span class="text-center">-</span></button>
                  <button class="plus" @click="addLocali"><span class="text-center">+</span></button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>Bagni*</label>
              </div>
              <div class="col-lg-6 col-12 ml-2">
                <div class="form-group d-flex">
                  <span class="pt-1 mr-3"> {{ this.bathrooms }} </span>
                  <button class="minus ml-2 mr-2" @click="removeBagni"><span class="text-center">-</span></button>
                  <button class="plus" @click="addBagni"><span class="text-center">+</span></button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="piano_appartamento_show !== false" class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>Piano appartamento*</label>
              </div>
              <div class="col-lg-6 col-12">
                <select class="form-control" @change="filter($event)" name="piano_appartamento" v-model="floor_number" aria-label="Seleziona" required>
                  <option value="" disabled selected>Seleziona</option>
                  <option v-for="item in piano_appartamento" :value="item.value" :key="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>N. piani edificio*</label>
              </div>
              <div class="col-lg-6 col-12">
                <select class="form-control" name="piano_edificio" aria-label="Seleziona" v-model="building_floors" required>
                  <option value="" disabled selected>Seleziona</option>
                  <option v-for="item in piani_edificio" :value="item.value" :key="item.value" :disabled="item.disabled">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>Riscaldamento*</label>
              </div>
              <div class="col-lg-6 col-12">
                <select class="form-control" name="riscaldamento" aria-label="Seleziona" v-model="heating">
                  <option value="" disabled selected>Seleziona</option>
                  <option v-for="item in riscaldamento" :value="item.value" :key="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>Classe energetica</label>
              </div>
              <div class="col-lg-6 col-12">
                <select class="form-control" name="classe_energetica" aria-label="Seleziona" v-model="energetic_class">
                  <option value="" selected>Seleziona</option>
                  <option v-for="item in classe_energetica" :value="item.value" :key="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>Anno di costruzione</label>
              </div>
              <div class="col-lg-6 col-12">
                <input type="number" name="ano_costruzione" class="form-control" v-model="year_built" placeholder="es: 1950" />
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label>Stato costruzione</label>
              </div>
              <div class="col-lg-6 col-12">
                <select class="form-control" name="stato_costruzione" aria-label="Seleziona" v-model="property_status">
                  <option value="" selected>Seleziona</option>
                  <option v-for="item in stato_costruzione" :value="item.value" :key="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <wizard-footer :step="this.step" :display_next_button="display_next_button" :wizard_data="getWizardData" :user="this.user" @is_villa="hidePianoAppartamento"> </wizard-footer>
      </wizard-box-left>
      <wizard-box-right :id="this.step">
        <wizard-progress :progress="this.progress" :progress_title="this.progress_title" :progress_description="this.progress_description"></wizard-progress>
      </wizard-box-right>
    </template>
  </wizard-layout>
</template>

<script>
import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardHeader from "@/Pages/Wizard/Elements/WizardHeader";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import WizardButtonStep2 from "@/Pages/Wizard/Elements/WizardButtonStep2";
import WizardProgress from "@/Pages/Wizard/Elements/WizardProgress";
import Button from "@/Jetstream/Button";
import { redirectWizardSteps } from "@/helpers/helper";
import { apt_floor_options, building_floors_options, energy_class_options, heating_options, conditions_options } from "../../../helpers/select-options";

export default {
  props: ["data", "user"],

  components: {
    Button,
    WizardProgress,
    WizardButtonStep2,
    WizardFooter,
    WizardHeader,
    WizardStep,
    WizardBoxLeft,
    WizardLayout,
    WizardBoxRight,
  },

  computed: {
    display_next_button() {
      return this.fieldsAreEmpty();
    },

    getWizardData() {
      return {
        surface: this.surface,
        rooms: this.rooms,
        bathrooms: this.bathrooms,
        floor_number: this.floor_number,
        building_floors: this.building_floors,
        heating: this.heating,
        energetic_class: this.energetic_class,
        year_built: this.year_built,
        property_status: this.property_status,
      };
    },
  },

  data() {
    let current_property = JSON.parse(localStorage.getItem("current_property"));
    return {
      step: 3,
      header_step: 4,
      title: "Le caratteristiche del tuo immobile",
      progress: 2,
      progress_title: "Definisci le caratteristiche del tuo immobile.",
      progress_description: "Per ricevere una valutazione accurata del tuo immobile è fondamentale conoscere tutte le sue caratteristiche.",
      surface: current_property.surface !== null ? current_property.surface : "",
      rooms: current_property.rooms !== null ? parseInt(current_property.rooms) : 0,
      bathrooms: current_property.bathrooms !== null ? parseInt(current_property.bathrooms) : 0,
      floor_number: current_property.floor_number !== null ? current_property.floor_number : "",
      building_floors: current_property.building_floors !== null ? current_property.building_floors : "",
      heating: current_property.heating !== null ? current_property.heating : "",
      energetic_class: current_property.energetic_class !== null ? current_property.energetic_class : "",
      year_built: current_property.year_built !== null ? current_property.year_built : "",
      property_status: current_property.property_status !== null ? current_property.property_status : "",
      piano_appartamento: apt_floor_options,
      piani_edificio: building_floors_options,
      classe_energetica: energy_class_options,
      riscaldamento: heating_options,
      stato_costruzione: conditions_options,
      piano_appartamento_show: current_property.typology !== "Villa Indipendente",
    };
  },

  methods: {
    isAgency() {
      return this.user !== null && !window.location.href.includes("customer");
    },

    addBagni() {
      this.bathrooms < 10 ? this.bathrooms++ : this.bathrooms;
    },
    removeBagni() {
      if (this.bathrooms === 0) {
        return;
      }
      this.bathrooms--;
    },
    addLocali() {
      this.rooms < 10 ? this.rooms++ : this.rooms;
    },
    removeLocali() {
      if (this.rooms === 0) {
        return;
      }
      this.rooms--;
    },

    filter(event) {
      this.piani_edificio.forEach(function (item) {
        if (item.value < event.target.value) {
          item.disabled = true;
        }

        if (item.value === 9) {
          item.disabled = false;
        }
      });
    },

    fieldsAreEmpty() {
      let required_fields = this.surface !== "" && this.rooms !== 0 && this.bathrooms !== 0 && this.building_floors !== "" && this.heating !== "";

      if (this.piano_appartamento_show !== false) {
        return required_fields && this.floor_number !== "";
      } else {
        return required_fields;
      }
    },
  },

  beforeMount() {
    redirectWizardSteps(this.isAgency(), this.step, "test", this.$inertia);
  },
};
</script>
